var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / More") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-More",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(13.333333, 4.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08088333,19.9190483 C4.86193167,20.7000967 4.86193167,21.9664317 4.08088333,22.7474817 C3.299835,23.52853 2.0335,23.52853 1.25245,22.7474817 C0.471401667,21.9664333 0.471401667,20.7000983 1.25245,19.9190483 C2.03349833,19.138 3.29983333,19.138 4.08088333,19.9190483",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08088333,10.5857817 C4.86193167,11.36683 4.86193167,12.633165 4.08088333,13.414215 C3.299835,14.1952633 2.0335,14.1952633 1.25245,13.414215 C0.471401667,12.6331667 0.471401667,11.3668317 1.25245,10.5857817 C2.03349833,9.80473333 3.29983333,9.80473333 4.08088333,10.5857817",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08088333,1.25244833 C4.86193167,2.03349667 4.86193167,3.29983167 4.08088333,4.08088167 C3.299835,4.86193 2.0335,4.86193 1.25245,4.08088167 C0.471401667,3.29983333 0.471401667,2.03349833 1.25245,1.25244833 C2.03349833,0.4714 3.29983333,0.4714 4.08088333,1.25244833",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.5357b5f0514767c5d87c19249bbdc148.svg";
export { ForwardRef as ReactComponent };